module.exports = __webpack_public_path__ + "img/forbes.c1757d88.svg";